<template>
  <div>
    <!-- Configuration gate -->
    <div class="config-gate" v-if="!chatbotConfig">
      <h2>Select chatbot configuration</h2>

      <div class="config-gate__field">
        <label>
          Company
          <select v-model="company">
            <option disabled value="">Select a company</option>
            <option
              v-for="c in companies"
            :key="c.id"
            :value="c.publicName"
            >
          {{ c.publicName }}
            </option>
          </select>
        </label>
      </div>

      <div class="config-gate__field">
        <label>
          Passcode
          <input v-model="passcode" type="password" />
        </label>
      </div>

      <button class="config-gate__button" @click="selectConfiguration">
        Start chat
      </button>

      <p v-if="errorMessage" class="config-gate__error">
        {{ errorMessage }}
      </p>
    </div>

    <!-- Chatbot only shows once a configuration has been selected -->
    <chatbot-widget
      v-if="chatbotConfig"
      :configuration="chatbotConfig"
      @redirection="evt => handleRedirection(evt)"
    />
  </div>
</template>

<script>
  import { findConfigurationByCompanyAndPasscode, getCompanies } from '../firebase';

export default {
  name: 'ConfigGate',
  data() {
    return {
      chatbotConfig: null, // will be set after a valid selection
      company: '',
      passcode: '',
      errorMessage: '',
      companies: [],
    };
  },
  async created() {
    const savedConfig = sessionStorage.getItem('chatbotConfig');
    if (savedConfig) {
      this.chatbotConfig = savedConfig;
    }
    this.companies = await getCompanies();
  },
  methods: {
    async selectConfiguration() {
      this.errorMessage = '';

      const key = (this.company || '').trim();
      const code = (this.passcode || '').trim();

      try {
        const website = await findConfigurationByCompanyAndPasscode(key, code);

        if (!website) {
          this.errorMessage = 'Invalid company or passcode.';
          return;
        }

        this.chatbotConfig = website.id;
      } catch (error) {
        this.errorMessage = 'Invalid company or passcode.';
      }

      sessionStorage.setItem('chatbotConfig', this.chatbotConfig);
    },
    handleRedirection(evt) {
      console.log('Redirection event:', evt.detail[0].url);
      console.log('Redirection event utm_source:', evt.detail[0].utm_source);
      window.location.href = evt.detail[0].url;
    },
  },
};
</script>

<style>
.config-gate {
  margin: 20px 0;
  padding: 16px;
  max-width: 400px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #fafafa;
}

.config-gate__field {
  margin-bottom: 12px;
}

.config-gate__field label {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.config-gate__field input,
.config-gate__field select {
  margin-top: 4px;
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.config-gate__button {
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  background: #42b983;
  color: #fff;
  cursor: pointer;
}

.config-gate__button:hover {
  background: #36976b;
}

.config-gate__error {
  margin-top: 8px;
  color: #c62828;
  font-size: 13px;
}
</style>
